export function findMaxTabSize(tabsWidths, availableSpace, marging = 20) {



    let tabsMaxWidths = tabsWidths.reduce((a, b) => Math.min(a, b), Number.POSITIVE_INFINITY);
    let tabsWidthsSum  = tabsWidths.map(w => Math.min(w, tabsMaxWidths)).reduce((a, b) => a + b, 0);

    // si trop petit on ajoute des pixel
    if (tabsWidthsSum < availableSpace - marging) {

        const canGrow = availableSpace - tabsWidthsSum
        // console.log({canGrow})
     
        return tabsMaxWidths + (canGrow / tabsWidths.length)
    }

    // si trop gros
    do {
        tabsWidthsSum = tabsWidths.map(w => Math.min(w, tabsMaxWidths)).reduce((a, b) => a + b, 0)

        // console.log(tabsWidthsSum, availableSpace, availableSpace - tabsWidthsSum)

        tabsMaxWidths -= 1

    } while (tabsWidthsSum > availableSpace)

    return tabsMaxWidths + 1
}